import { render, staticRenderFns } from "./sales-detail.vue?vue&type=template&id=7eefc1f5&scoped=true&"
import script from "./sales-detail.vue?vue&type=script&lang=ts&"
export * from "./sales-detail.vue?vue&type=script&lang=ts&"
import style0 from "./sales-detail.vue?vue&type=style&index=0&id=7eefc1f5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eefc1f5",
  null
  
)

export default component.exports